import { queryOptions } from "@tanstack/react-query";

import clientSDK from "~/api/clientSDK";

import { toConnectableIntegration, toConnection } from "./adapter/to-connection";
import { toIntegrationCatalogEntry } from "./adapter/to-integration-catalog-entry";

export const connectionQueryKeys = {
  credentials: ["connections", "credentials"] as const,
  integrations: ["connections", "integrations"] as const,
  integrationCatalog: ["connections", "integration-catalog"] as const,
};

export const connectionQueryOptions = {
  credentials: () =>
    queryOptions({
      queryKey: connectionQueryKeys.credentials,
      queryFn: () => clientSDK.listCredentials(),
      select: (credentials) => credentials.map(toConnection),
      refetchOnWindowFocus: false,
    }),
  connectableIntegrations: () =>
    queryOptions({
      queryKey: connectionQueryKeys.integrations,
      // All integrations are connectable: OAUTH2 via the browser link flow, others (e.g. basic
      // username/password) by entering the secret. The UI branches on each one's authType.
      // Admin-configured set, expected well under 100; one max-size page (like the admin
      // integrations page) instead of the SDK's default of 10, which would silently truncate.
      queryFn: () => clientSDK.listAuthIntegrations(undefined, undefined, undefined, 1, 100),
      select: (page) => page.items.map(toConnectableIntegration),
      refetchOnWindowFocus: false,
    }),
  integrationCatalog: () =>
    queryOptions({
      queryKey: connectionQueryKeys.integrationCatalog,
      queryFn: () => clientSDK.getIntegrationCatalog(),
      select: (entries) => entries.map(toIntegrationCatalogEntry),
      refetchOnWindowFocus: false,
    }),
};
